import { m } from 'framer-motion';
// @mui
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
// import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { usePopover } from 'minimal-shared/hooks';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// hooks
// import { useMockedUser } from 'src/hooks/use-mocked-user';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import { transitionTap, varHover, varTap } from 'src/components/animate';
import { useSnackbar } from 'src/components/snackbar';
import { CustomPopover } from 'src/components/custom-popover';

import { localStorageGetItem, AUTH_STORAGE_KEYS } from 'src/utils/storage-available';

// ----------------------------------------------------------------------

// const OPTIONS = [
// {
//   label: 'Home',
//   linkTo: '/',
// },
// {
//   label: 'Profile',
//   linkTo: paths.dashboard.user.profile,
// },
// {
//   label: 'Settings',
//   linkTo: paths.dashboard.user.account,
// },
// ];

// ----------------------------------------------------------------------

export default function AccountPopover() {
  const router = useRouter();

  // const { user } = useMockedUser();
  const user = JSON.parse(localStorageGetItem(AUTH_STORAGE_KEYS.user) || '{}');

  const { logout } = useAuthContext();

  const { enqueueSnackbar } = useSnackbar();

  const popover = usePopover();

  const handleLogout = async () => {
    try {
      await logout();
      popover.onClose();
      // TODO: Base path needs to be changed when firebase is used for auth
      router.replace(paths.login);
    } catch (error) {
      console.error(error);
      enqueueSnackbar('Unable to logout!', { variant: 'error' });
    }
  };

  // const handleClickItem = (path: string) => {
  //   popover.onClose();
  //   router.push(path);
  // };

  const renderMenuActions = () => (
    <CustomPopover
      open={popover.open}
      anchorEl={popover.anchorEl}
      onClose={popover.onClose}
      slotProps={{ paper: { sx: { p: 0, width: 200 } }, arrow: { offset: 20 } }}
    >
      <Box sx={{ p: 2, pb: 1.5 }}>
        <Typography variant="subtitle2" noWrap>
          {user?.fullName}
        </Typography>

        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {user?.email}
        </Typography>
      </Box>

      <Divider sx={{ borderStyle: 'dashed' }} />

      {/* <Stack sx={{ p: 1 }}>
        {OPTIONS.map((option) => (
          <MenuItem key={option.label} onClick={() => handleClickItem(option.linkTo)}>
            {option.label}
          </MenuItem>
        ))}
      </Stack> */}

      <Divider sx={{ borderStyle: 'dashed' }} />

      <MenuItem
        onClick={handleLogout}
        sx={{ m: 1, fontWeight: 'fontWeightBold', color: 'error.main' }}
      >
        Logout
      </MenuItem>
    </CustomPopover>
  );

  const renderActionButton = () => (
    <IconButton
      component={m.button}
      whileTap={varTap(0.96)}
      whileHover={varHover(1.04)}
      transition={transitionTap()}
      aria-label="Account button"
      onClick={popover.onOpen}
      sx={{
        width: 40,
        height: 40,
        background: (theme) => alpha(theme.palette.grey[500], 0.08),
        ...(popover.open && {
          background: (theme) =>
            `linear-gradient(135deg, ${theme.palette.primary.light} 0%, ${theme.palette.primary.main} 100%)`,
        }),
      }}
    >
      <Avatar
        src=""
        alt={user?.fullName}
        sx={{
          width: 36,
          height: 36,
          border: (theme) => `solid 2px ${theme.palette.background.default}`,
        }}
      >
        {user?.fullName?.charAt(0)?.toUpperCase()}
      </Avatar>
    </IconButton>
  );

  return (
    <>
      {renderActionButton()}
      {renderMenuActions()}
    </>
  );
}
